<template>
  <client-only>
    <v-row class="calculator-content ma-0" align-content="center">
      <v-row class="calculator-inner">
        <v-col class="px-1 py-0 my-md-0 mt-6 mb-0" cols="12" sm="5">
          <GLocationAutocomplete
            :showRectangled="true"
            :isText="true"
            @updateLocation="updateUsersLocation"
            class="adress-top"
          />
        </v-col>

        <v-col class="px-0 py-0 my-md-0 my-6" cols="12" sm="4">
          <v-btn-toggle
            v-model="travelMode"
            background-color="transparent"
            dense
            mandatory
          >
            <v-btn
              class="transport px-5 mx-2"
              value="DRIVING"
              active-class="active-button"
            >
              <v-icon
                right
                dark
                color="primary"
                :class="'icon-sport-car ma-0'"
              />
            </v-btn>
            <v-btn
              class="transport px-5"
              value="TRANSIT"
              active-class="active-button"
            >
              <v-icon right dark color="primary" :class="'icon-bus ma-0'" />
            </v-btn>
          </v-btn-toggle>
        </v-col>

        <v-col class="py-0" cols="12" sm="2">
          <v-btn
            @click="calculateDistance"
            :disabled="!isLocation"
            color="white"
            class="primary--text"
            rounded
          >
            {{ text }}
          </v-btn>
        </v-col>
      </v-row>
    </v-row>
  </client-only>
</template>

<script>
import { isEmpty } from 'lodash';
import GLocationAutocomplete from '@/components/Forms/Form_Fields/GLocationAutocomplete';

export default {
  components: {
    GLocationAutocomplete,
  },

  props: {
    latitude: {
      type: Number,
    },
    longitude: {
      type: Number,
    },
    address: {
      type: String,
    },
    isMobile: {
      type: Boolean,
    },
  },

  data() {
    return {
      text: 'חישוב  ',
      startPoint: undefined,
      travelMode: 'DRIVING',
      directionsDisplay: undefined,
      usersLatitude: undefined,
      usersLongitude: undefined,
    };
  },

  computed: {
    distance() {
      return !isEmpty(this.directionsDisplay)
        ? this.directionsDisplay.routes[0].legs[0].duration.text
        : '';
    },

    isLocation() {
      return this.usersLatitude && this.usersLongitude ? true : false;
    },
  },

  watch: {
    distance(newVal, oldVal) {
      this.$emit('displayDuration', newVal);
    },
  },

  methods: {
    calculateAndDisplayRoute(callback) {
      new Promise((resolve, reject) => {
        var service = new google.maps.DirectionsService();

        return service.route(
          {
            origin: this.startPoint,
            destination: this.address,
            travelMode: this.travelMode,
          },
          (response, status) => {
            if (status === 'OK') {
              resolve(callback(response, status));
            }
            reject(status);
          }
        );
      });
    },

    async calculateDistance() {
      try {
        await this.calculateAndDisplayRoute((response, status) => {
          this.directionsDisplay = response;

          this.$nuxt.$emit('showRoute', this.travelMode);

          return true;
        });
      } catch (e) {
        console.log(e);
      }
    },

    updateUsersLocation(location) {
      this.startPoint = location.address;
      this.usersLongitude = location.lng;
      this.usersLatitude = location.lat;
      let usertsLocation = {};
      usertsLocation.address = this.startPoint;
      usertsLocation.lng = this.usersLongitude;
      usertsLocation.lat = this.usersLatitude;
      //emit event to google map
      this.$nuxt.$emit('updateUsersLocationOnMap', usertsLocation);
    },

    chooseMode(value) {
      this.travelMode = value;
    },
  },

  beforeDestroy() {
    this.startPoint = undefined;
  },
};
</script>

<style lang="scss" scoped>
$btn-toggle-btn-height: '20px';

.calculator-inner {
  flex-direction: row;

  background: #3e4a54;
}
.calc--mobile {
  background: white;
}
.active-button.v-btn--active {
  background: #fff !important;
}
.transport {
  background: #f2f2f2;
  border: 1px solid rgb(226, 226, 226) !important;
}
.v
  #app
  > div
  > div:nth-child(3)
  > div
  > div
  > div:nth-child(6)
  > div.calculator-wrapper.mobile--calc
  > div
  > div
  > div {
  padding: 10px !important;
  margin: 0px !important;
}
.transport-ico {
  font-size: 34px;
}

.calculator--mobile {
  width: 100%;
  text-align: center;
  align-items: center;
}

.adress-top {
  background-color: #fff;
  border-radius: 5px;
  max-width: 300px;
  margin: 0 auto;
}
@media screen and (min-width: 600px) {
  .calculator-content {
    padding: 0;
    position: relative;
  }
  .calculator-inner {
    flex-direction: row;

    background: #3e4a54;
  }
  .close-calc {
    position: relative;
    top: 10px;
    right: 10%;
  }
}
</style>
